import { render, staticRenderFns } from "./WrittenResponseStep.vue?vue&type=template&id=ddb60840"
import script from "./WrittenResponseStep.vue?vue&type=script&lang=ts"
export * from "./WrittenResponseStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports